import http from '@/http';

const types = {
    TABLE_SET_RESOURCES: 'TABLE_SET_RESOURCES',
};

// state
export default {
    state() {
        return {
            resources: [],
        };
    },
    mutations() {
        return {
            [types.TABLE_SET_RESOURCES](state, resources) {
                state.resources = resources;
            },
        };
    },
    actions(name) {
        return {
            fetch({ commit }, { filters, pagination, sort }) {
                return http
                    .get(`${name}/builder`, {
                        params: {
                            ...filters,
                            ...pagination,
                            sort,
                        },
                    })
                    .then((paginatedData) => {
                        commit(types.TABLE_SET_RESOURCES, paginatedData.data);

                        return paginatedData;
                    });
            },
        };
    },
};
